import firebase from 'firebase';
import Vue from 'vue';
import VueRouter from 'vue-router';

import Inscription from '@/views/Inscription';
import Formateurs from '@/views/Formateurs';
import Contact from '@/views/Contact';
import Home from '@/views/Home';
import Login from '@/views/Login';
import Formations from '@/views/Formations';
import Profile from '@/views/Profile'
import Rgpd from '@/views/Rgpd'
import QuiSommeNous from '@/views/QuiSommeNous'
import PriseEnCharge from '@/views/PriseEnCharge'
import Fonctionnement from '@/views/Fonctionnement'

Vue.use(VueRouter);

const router = new VueRouter({

  mode: 'history',
  base: '/',
  routes: [
    {
      path: "/medecins",
      name: "Medecins",
      meta: {
        title: "medecins"
      },
      beforeEnter: () => {
        window.location.href = 'http://medecins.oforis.com';
      }
    },
    {
      path: "/secretaires",
      name: "Secretaires",
      meta: {
        title: "secretaires"
      },
      beforeEnter: () => {
        window.location.href = 'http://secretaires.oforis.com';
      }
    },
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/qui-sommes-nous',
      name: 'Qui sommes nous',
      component: QuiSommeNous,
      meta: { title: 'Qui sommes nous?' }
    },
    {
      path: '/fonctionnement',
      name: 'Fonctionnement',
      component: Fonctionnement,
      meta: { title: 'Fonctionnement et prise en charge des formations OFORIS ' }
      
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: 'Oforis - Connexion' }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
        title: 'OFORIS, formations médicales spécialisées' 
      },
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { title: 'Contactez l’équipe d’OFORIS' }
    },
    {
      path: '/formateurs',
      name: 'Formateurs',
      component: Formateurs,
      meta: { title: 'Les formateurs d’OFORIS, des médecins spécialistes de leur domaine' }
    },
    {
      path: '/inscription',
      name: 'Iscription',
      component: Inscription,
      meta: { title: 'Oforis - Inscription' }
    },
    {
      path:'/formations',
      name:'Formations',
      component: Formations,
      meta: { title: 'Toutes les formations OFORIS' }
    },
    {
      path: '/profil',
      name: 'Profil',
      component: Profile,
      meta: { title: 'Créer et gérer votre compte OFORIS' }
    },
    {
      path: '/rgpd',
      name: 'RGPD',
      component: Rgpd,
      meta: { title: 'Oforis - RGPD' }
    }
  ]
});
const DEFAULT_TITLE = 'Oforis';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
      document.title = to.meta.title || DEFAULT_TITLE;
      document.meta
    });
});
/*
router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser) next('home');
  else next();
});
*/
export default router;
